import { CmsMeta } from '../cmsMeta';
import './CmsMolecule.css';
import { ReactNode } from 'react';

type CmsMoleculeProps = { className?: string; children: ReactNode };
export const CmsMolecule = ({ className, children }: CmsMoleculeProps) => {
	return <div className={'cms-molecule ' + className}>{children}</div>;
};

export const cmsMeta: CmsMeta = {
	description: 'A plain wrapper that takes a css class, for grouping children when a layout needs a hook to style.',
	example: ['CmsMolecule', { className: 'intro' }, ['CmsHtml', { content: '<p>Text</p>' }]],
};
